import { render, staticRenderFns } from "./winloss.vue?vue&type=template&id=948540ce&scoped=true&"
import script from "./winloss.vue?vue&type=script&lang=js&"
export * from "./winloss.vue?vue&type=script&lang=js&"
import style0 from "./winloss.vue?vue&type=style&index=0&id=948540ce&scoped=true&lang=css&"
import style1 from "./winloss.vue?vue&type=style&index=1&id=948540ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948540ce",
  null
  
)

export default component.exports